const Single = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Privileges/Single')
const Search = () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/Privileges/Search')

export default [
  {
    path: 'privileges/create',
    name: 'PrivilegesCreate',
    component: Single,
    meta: {
      title: 'Adicionar Privilégio',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'privileges',
        action: 'create'
      }
    }
  },
  {
    path: 'privileges/:id',
    name: 'PrivilegesEdit',
    component: Single,
    meta: {
      title: 'Editar Privilégio',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'privileges',
        action: 'read'
      }
    }
  },
  {
    path: 'privileges',
    name: 'PrivilegesSearch',
    component: Search,
    meta: {
      title: 'Privilégios',
      ensureCanSeeFunctionalities: true,
      permission: {
        name: 'privileges',
        action: 'read'
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/dashboard/privileges.js